"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var join = {
    id: 10,
    error: '',
    message: '',
    success: true,
    userAlreadyExists: false,
};
exports.default = join;
